import { CATEGORIES } from '../helpers/categories.js';
import { loadCategories } from '../functions.js';
import { isAuthenticated, getUser, login, logout } from '../auth/auth0.js';
import { getUserProfile, getUserAvatar } from '../userContext.js';

export async function buildMobileNav() {
  const mobileNav = document.getElementById('mobile-nav');
  if (!mobileNav) return;

  try {
   const { grouped } = await loadCategories();

    // Filter groups to only those with at least one active category
    const activeGroups = Object.entries(grouped).filter(([, cats]) =>
      cats.some(cat => cat.recipeCount > 0)
    );

    const html = `
      <ul class="mobile-nav-list">
        ${activeGroups.map(([group, cats]) => {
          const activeCats = cats.filter(cat => cat.recipeCount > 0);
          const groupId = `mobile-group-${group.toLowerCase()}`;
          return `
            <li class="mobile-nav-group">
              <button class="mobile-nav-group-btn" aria-expanded="false" aria-controls="${groupId}">
                ${group}
                <i class="fa fa-chevron-right"></i>
              </button>
              <ul id="${groupId}" class="mobile-nav-subcategories" hidden>
                ${activeCats.map(cat => `
                  <li>
                    <a href="/category/${cat.slug}" class="mobile-nav-link">
                      ${cat.name}
                    </a>
                  </li>
                `).join('')}
              </ul>
            </li>
          `;
        }).join('')}
        <li class="mobile-nav-divider"></li>
        <li><a href="/" class="mobile-nav-link">Home</a></li>
   
         <li><a href="/edit.html" data-requires-auth class="mobile-nav-link mobile-nav-create">
          <i class="fa fa-plus"></i> Create Recipe
        </a></li>

        <li class="mobile-nav-divider"></li>
        <li class="mobile-nav-divider"></li>
        <li>
          <button class="mobile-nav-link" id="mobile-badge-toggle">
            <i class="fa fa-eye"></i> Hide recipe badges
          </button>
        </li>
        <li id="mobile-nav-auth"></li>
      </ul>
    `;

    mobileNav.innerHTML = html;
const badgeBtn = mobileNav.querySelector('#mobile-badge-toggle');
if (badgeBtn) {
  // sync with existing badge toggle state
  const existing = document.getElementById('badgeToggle');
  badgeBtn.addEventListener('click', () => {
    existing?.click();
    const hidden = document.body.classList.contains('badges-hidden');
    badgeBtn.innerHTML = `<i class="fa fa-eye${hidden ? '' : '-slash'}"></i> ${hidden ? 'Show' : 'Hide'} recipe badges`;
  });
}
// Inject auth state
const authEl = mobileNav.querySelector('#mobile-nav-auth');
if (authEl) {
  let authenticated =- false;
 try {
    authenticated = await isAuthenticated();
  } catch (e) {
    // Auth0 not yet initialized — treat as logged out, nav will render login button
  }
  if (authenticated) {
    const profile = getUserProfile();
    const avatar = getUserAvatar();
    const displayName = profile?.profile?.displayName || profile?.username || 'Chef';
    authEl.innerHTML = `
      <div class="mobile-nav-user">
        <img src="${avatar}" alt="${displayName}" class="mobile-nav-avatar">
        <span class="mobile-nav-username">${displayName}</span>
      </div>
      <a href="/profile.html" class="mobile-nav-link">My Profile</a>
      <button class="mobile-nav-link mobile-nav-logout" id="mobile-nav-logout-btn">
        <i class="fa fa-sign-out"></i> Log out
      </button>
    `;
    mobileNav.querySelector('#mobile-nav-logout-btn')?.addEventListener('click', () => {
      localStorage.removeItem('userProfile');
      logout();
    });
  } else {
    authEl.innerHTML = `
      <button class="mobile-nav-link mobile-nav-login" id="mobile-nav-login-btn">
        <i class="fa fa-user"></i> Log in
      </button>
    `;
    mobileNav.querySelector('#mobile-nav-login-btn')?.addEventListener('click', () => {
      login();
    });
  }
}
    // Wire accordion
    mobileNav.querySelectorAll('.mobile-nav-group-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        const sublist = document.getElementById(btn.getAttribute('aria-controls'));

        // Close all others
        mobileNav.querySelectorAll('.mobile-nav-group-btn').forEach(other => {
          other.setAttribute('aria-expanded', 'false');
          other.querySelector('i').className = 'fa fa-chevron-right';
          const otherId = other.getAttribute('aria-controls');
          document.getElementById(otherId)?.setAttribute('hidden', '');
        });

        // Toggle this one
        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          btn.querySelector('i').className = 'fa fa-chevron-down';
          sublist?.removeAttribute('hidden');
        }
      });
    });

    // Close nav when a link is clicked
    mobileNav.querySelectorAll('.mobile-nav-link').forEach(link => {
      link.addEventListener('click', () => {
        const toggle = document.getElementById('menu-toggle');
        if (toggle) toggle.click();
      });
    });

  } catch (error) {
    console.error('Failed to build mobile nav:', error);
  }
}